import axios from 'axios';

import { getLogger } from '../logger';
import {
  API_DISCUSSION,
  API_DISCUSSION_POSTS,
  API_DISCUSSIONS,
  API_STATEMENTS,
  API_CONTENT_BY_ACTIVITY_ID,
  API_CLASSROOMS_BOOKS
} from '../../services/api/apiConst';
import { PARAMS, DISCUSSIONS_PER_PAGE, POSTS_PER_PAGE, DISCUSSION_MESSAGES_ORDER_OBJECT } from '../../const';

const debug = getLogger('services:api:discussionApi');

//----------------------------------------------------------------------------------------------------------------------
export const getPaginatedDiscussions = (classroomId, status, page = 0, size = DISCUSSIONS_PER_PAGE) => {
  if (classroomId && page > -1) {
    const params = { page, size, sectionId: classroomId };

    if (status) {
      params.status = status;
    }

    return axios.get(API_DISCUSSIONS, { params }).then(res => res.data);
  }
  debug.error('[getPaginatedDiscussions] Classroom id or page is empty');
  return new Promise((resolve, reject) => reject({ classroomId, status, page, size }));
};

// CONTENT DISSCUSIONS
export const getUnitAndLessonContentDiscussion = async (discussion, classroom) => {
  const unitUrl = `${API_CONTENT_BY_ACTIVITY_ID.replace('$idActivity', discussion.activityContext.unitId).replace(
    '$idClassroom',
    classroom.id
  )}`;
  const lessonUrl = `${API_CONTENT_BY_ACTIVITY_ID.replace('$idActivity', discussion.activityContext.lessonId).replace(
    '$idClassroom',
    classroom.id
  )}`;

  const [unitResponse, lessonResponse] = await Promise.all([axios.get(unitUrl), axios.get(lessonUrl)]);

  const unitTitle = Object.values(unitResponse.data.title)[0];
  const lessonTitle = Object.values(lessonResponse.data.title)[0];

  return {
    unitTitle,
    lessonTitle,
    unit: unitResponse.data,
    lesson: lessonResponse.data
  };
};

export const getDiscussionContentBook = async (discussion, classroom) => {
  const url = `${API_CLASSROOMS_BOOKS.replace('$idClassroom', classroom.id)}`;

  const response = await axios.get(url);
  const books = response.data;

  const book = books.find(book => book.activityId === discussion.activityContext.bookId);

  return {
    book: book ? book : null
  };
};

export const createDiscussion = discussion => {
  if (discussion) {
    return axios.post(API_DISCUSSIONS, discussion);
  }
  debug.error('[createDiscussion] Discussion is empty');
  return new Promise((resolve, reject) => reject({ discussion }));
};

export const updateDiscussion = (discussion, discussionId) => {
  if (discussion) {
    return axios.patch(API_DISCUSSION.replace(PARAMS.DISCUSSION, discussionId), discussion);
  }
  debug.error('[updateDiscussion] Discussion is empty');
  return new Promise((resolve, reject) => reject({ discussion, discussionId }));
};

export const deleteDiscussion = discussionId => {
  if (discussionId) {
    return axios.delete(API_DISCUSSION.replace(PARAMS.DISCUSSION, discussionId));
  }
  debug.error('[deleteDiscussion] Discussion is empty');
  return new Promise((resolve, reject) => reject({ discussionId }));
};

export const getDiscussion = discussionId => {
  if (discussionId) {
    return axios.get(API_DISCUSSION.replace(PARAMS.DISCUSSION, discussionId));
  }
  debug.error('[getDiscussion] Classroom id or discussion id is empty');
  return new Promise((resolve, reject) => reject({ discussionId }));
};

export const getDiscussionMessages = (
  discussionId,
  sort = DISCUSSION_MESSAGES_ORDER_OBJECT.OLDER_FIRST.key,
  page = 0,
  size = POSTS_PER_PAGE
) => {
  if (discussionId && page > -1) {
    const params = { page, size, sort: `timestamp,replies.timestamp,${sort}` };
    return axios.get(API_DISCUSSION_POSTS.replace(PARAMS.DISCUSSION, discussionId), { params }).then(res => res.data);
  }
  debug.error('[getDiscussionMessages] Discussion id, status or page is empty');
  return new Promise((resolve, reject) => reject({ discussionId, sort, page, size }));
};

export const sendStatements = statements => {
  return axios.post(API_STATEMENTS, statements);
};
